// extracted by mini-css-extract-plugin
export var scrollArea = "_pf-0";